<script>
import {productGroup as columns} from "../../../tables"

export default {
  data() {
    return {
      columns,
      form: this.$form.createForm(this),
      loading: false,
      expand: false,
      items: {},
      filters: {
        q: null,
        page: 1,
        per_page: 10,
      }
    }
  },
  created() {
    this.items = this.getDefaultPagination()
    this.filters = _.merge(this.filters, this.$hyperion.request)
    this.getItems()
  },
  computed: {
    pageSize() {
      return parseInt(this.items.per_page)
    }
  },
  methods: {
    tableChanged(pagination) {
      this.filters.page = pagination.current
      this.filters.per_page = pagination.pageSize
      this.pushState(this.filters)
      this.getItems()
    },
    handleSubmit(e) {
      e.preventDefault()
      this.pushState(this.filters)
      this.getItems()
    },
    handleReset(e) {
      e.preventDefault()
      this.filters = {
        q: null,
        page: 1
      }
    },
    getItems() {
      this.loading = true
      this.$http.get(this.routeUri('hyperion.product-group'), {
        params: this.filters
      })
        .then((response) => this.items = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    }
  }
}
</script>
<template>
  <a-card type="inner" size="small">
    <a-form layout="inline" :form="form" @submit="handleSubmit">
      <a-row :gutter="24" class="form-filter-wrapper" :class="expand ? 'expanded' : ''">
        <a-col :span="6">
          <a-input placeholder="Keyword.." v-model="filters.q">
            <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)"/>
          </a-input>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24" class="text-right">
          <a-button type="primary" html-type="submit" icon="filter"
                    :style="{ display: expand ? 'inline-block' : 'none'}">Filter
          </a-button>
          <a-button class="ml-2" type="dashed" html-type="reset" icon="reload" @click="handleReset"
                    :style="{ display: expand ? 'inline-block' : 'none'}">Reset
          </a-button>

          <a class="ml-2" @click="() => this.expand = !this.expand ">
            Filter
            <a-icon :type="expand ? 'up' : 'down'"/>
          </a>
        </a-col>
      </a-row>
    </a-form>

    <a-divider dashed/>

    <a-skeleton :loading="loading" active>
      <a-table :columns="columns" :dataSource="items.data" rowKey="hash" :pagination="{ pageSize: pageSize, current: items.current_page, total: items.total, showSizeChanger: true }" @change="tableChanged">
        <div slot="name" slot-scope="record">
          <a-button size="small" type="link" icon="tag"/>
          {{ record.name }}
        </div>

        <div slot="description" slot-scope="record">
          {{ record.description }}
        </div>

        <p slot="updatedAt" slot-scope="updated_at" class="text-sm">
          <a-tooltip :title="moment(updated_at).format('YYYY-MM-DD HH:mm:ss')">
            {{ moment(updated_at).fromNow() }}
          </a-tooltip>
        </p>

        <div slot="action" slot-scope="record" class="text-center">
          <a-tooltip title="Edit Product Group">
            <a-button size="small" type="dashed" shape="circle" icon="pushpin"
                      :href="routeUri('hyperion.product-group.edit', { product_group_hash: record.hash })"/>
          </a-tooltip>
        </div>

      </a-table>
    </a-skeleton>
  </a-card>
</template>
